import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, Subject, finalize, map } from 'rxjs';
import { StatusService } from '../status.service';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { StatusAddPayload } from '../status.interface';
import { GenericRank } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-add-status-cerere',
    templateUrl: './add-status-cerere.component.html',
    styleUrls: ['./add-status-cerere.component.scss'],
})
export class AddStatusCerereComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    ranks$!: Observable<GenericRank[]>;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        bg_color: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        rank: new FormControl('', [Validators.required]),
        observations: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<AddStatusCerereComponent>,
        private statusService: StatusService,
        private notificationService: NotificationService,

        private authService: AuthService
    ) {
        this.processToken();
    }
    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadRanks();
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.statusService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, bg_color, slug, rank, observations } = this.form
            .value as StatusAddPayload;
        const newStatus: StatusAddPayload = {
            name,
            bg_color,
            slug,
            rank,
            observations,
        };

        this.statusService
            .storeStatus(newStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    loadRanks() {
        this.isLoading = true;
        this.ranks$ = this.statusService
            .getRanksList()
            .pipe(finalize(() => (this.isLoading = false)));
    }
}
